<div>
    <input type="text" class="form-control my-2" [(ngModel)]="cliniques" placeholder="Recherche Clinique">
    <nav class="tree-nav scroll">
        <div class="flex" *ngFor="let clinique of values | filterClinique:cliniques; let i = index">
            <div class="d-flex justify-content-start align-items-start flex-column">
                <span class="label">{{clinique.name}}</span>
            </div>
            <input type="radio" name="cliniqueRadio" class="checkbox" 
                   (change)="changed(clinique, $event, i)">
        </div>
    </nav>
    <button class="btn btn-primary ajouter" (click)="close()">Ajouter</button>
</div>